import React from 'react';
import styles from '../../styles/Breadcrumbs.module.css';
import {
  Home, PackageSearch, ChevronRight, FileText,
  Users, BarChart3, Scale, ShoppingCart, Link2,
  SendHorizonal, ShieldCheck, Code2, Terminal, Cloud, Workflow, UserCheck, ArrowLeftRight, AlertTriangle, Table2, BookOpenCheck, FolderGit2
} from 'lucide-react';

interface BreadcrumbsProps {
  currentPage: string;
  setPage: (page: string) => void;
}

// 1. Agregamos 'parent' para saber el camino de regreso
const pageRegistry: Record<string, { name: string; Icon: React.ElementType; parent?: string }> = {
  home: { name: 'Inicio', Icon: Home },
  ariba: { name: 'SAP Ariba', Icon: PackageSearch, parent: 'home' },
  btp: { name: 'SAP BTP', Icon: Cloud, parent: 'home' },
  'btp-integration-suite': { name: 'Integration Suite', Icon: Workflow, parent: 'btp' },
  'btp-iflows': { name: 'Repositorio de iFlows', Icon: FolderGit2, parent: 'btp-integration-suite' },
  'btp-cloud-identity': { name: 'Cloud Identity Service', Icon: UserCheck, parent: 'btp' },
  
  // Módulo Commerce
  commerce: { name: 'Commerce Automation', Icon: FileText, parent: 'ariba' },
  status: { name: 'Estatus Facturación', Icon: FileText, parent: 'commerce' },
  validacion: { name: 'Validación XML SUNAT', Icon: FileText, parent: 'commerce' },
  
  // Módulo APIs (El nuevo que creamos)
'ariba-apis': { name: 'API Explorer', Icon: Link2, parent: 'ariba' },
  'validador-estructura': { name: 'Validador de Estructura', Icon: ShieldCheck, parent: 'ariba' },
  'badis-toolbox': { name: 'BAdIs y Objetos ABAP', Icon: Code2, parent: 'ariba' },
  'transacciones-toolbox': { name: 'Transacciones SAP', Icon: Terminal, parent: 'ariba' },
  'interfaces-toolbox': { name: 'Interfaces / Canales', Icon: ArrowLeftRight, parent: 'ariba' },
  'errores-conocidos-toolbox': { name: 'Errores Conocidos', Icon: AlertTriangle, parent: 'ariba' },
  'tablas-toolbox': { name: 'Tablas SAP', Icon: Table2, parent: 'ariba' },
  'guias-integracion-toolbox': { name: 'Guías de Integración', Icon: BookOpenCheck, parent: 'ariba' },
  // Otros módulos
  slp: { name: 'SLP', Icon: Users, parent: 'ariba' },
  sourcing: { name: 'Sourcing', Icon: BarChart3, parent: 'ariba' },
  contracts: { name: 'Contracts', Icon: Scale, parent: 'ariba' },
  buying: { name: 'Buying', Icon: ShoppingCart, parent: 'ariba' },
  'envio-documentos': { name: 'envio documentos', Icon: SendHorizonal, parent: 'ariba' },
  
  // Dashboard "Mis APIs" (global, sin proyecto — ver comentario en HomeLanding.tsx) y sub-módulos
  'pruebas-apis': { name: 'Mis APIs', Icon: Code2, parent: 'home' },
  's4-apis': { name: 'APIs S/4HANA Cloud', Icon: Link2, parent: 'pruebas-apis' },
  'docusign-apis': { name: 'APIs Docusign', Icon: Link2, parent: 'pruebas-apis' },
  'ariba-api-test': { name: 'Ariba API Tester', Icon: Link2, parent: 'pruebas-apis' }
  
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ currentPage, setPage }) => {
  
  // 2. Función mágica: Construye el camino automáticamente
  const getPath = (pageKey: string): string[] => {
    const path: string[] = [];
    let current = pageKey;
    while (current && pageRegistry[current]) {
      path.unshift(current); // Agrega al inicio
      current = pageRegistry[current].parent || '';
    }
    return path;
  };

  const breadcrumbsPath = getPath(currentPage);

  return (
    <nav className={styles.nav} aria-label="Breadcrumb">
      <ol className="flex items-center list-none p-0 text-sm">
        {breadcrumbsPath.map((key, index) => {
          const isLast = index === breadcrumbsPath.length - 1;
          const info = pageRegistry[key];

          return (
            <li key={key} className="flex items-center">
              {/* Separador (no se muestra en el primer elemento) */}
              {index > 0 && (
                <span className="mx-2 text-gray-500 opacity-50">
                  <ChevronRight size={14} />
                </span>
              )}

              {isLast ? (
                // El último elemento no es clickeable
                <span className={`${styles.current} flex items-center gap-2 text-blue-400 font-medium`}>
                  <info.Icon size={16} />
                  {info.name}
                </span>
              ) : (
                // Los padres son clickeables
                <span 
                  className={`${styles.link} flex items-center gap-2 cursor-pointer hover:text-white transition-colors`} 
                  onClick={() => setPage(key)}
                >
                  <info.Icon size={16} />
                  {info.name}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;